import { countriesWithStates, countriesWithoutStates } from './config';

const buildDestinationRouteData = (DestinationWrapper) => {
  const countriesWithStatesRouteData = countriesWithStates.map((country) => ({
    name: 'destination',
    path: `/${country}/:state?/:area?`,
    component: DestinationWrapper,
  }));

  const countriesWithoutStatesRouteData = countriesWithoutStates.map((country) => ({
    name: 'destination',
    path: `/${country}/:area?`,
    component: DestinationWrapper,
  }));

  return [...countriesWithStatesRouteData, ...countriesWithoutStatesRouteData];
};

export default buildDestinationRouteData;
